import React, { useState } from 'react';
import { BubbleButton } from './BubbleUI';
import { copyToClipboard } from '@go-shared/lib/utils';

interface CopyToClipboardButtonPropsBase {
  copyText: string;
  label?: string;
}

type CopyToClipboardButtonProps = React.PropsWithChildren<CopyToClipboardButtonPropsBase>;

export function CopyToClipboardButton(props: CopyToClipboardButtonProps) {
  const { children, label, copyText } = props;
  const [copied, setCopied] = useState(false);

  return (
    <BubbleButton
      onClick={() => {
        if (copied) return;

        copyToClipboard(copyText);
        setCopied(true);

        setTimeout(() => {
          setCopied(false);
        }, 3000);
      }}
      size="small"
      className="p-1-i relative text-left whitespace-nowrap"
      variant="navy"
      inverse
      icon="copy"
    >
      {children ? children : copied ? 'Copied to Clipboard' : label || 'Copy'}
    </BubbleButton>
  );
}
